import { createActions } from 'redux-actions';

const PREFIX = 'PUBLICK_OFFER_PAGE';

export const { initialize } = createActions({
  initialize: () => undefined,
}, { prefix: PREFIX });
